(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
/* Single-open behavior: when a <details> inside a [data-faq-single-open]
   container opens, close its siblings. Uses the native 'toggle' event so
   it works with the existing <accordion-tab> wrapper without touching its
   internals. */
document.addEventListener('toggle', (e) => {
  const details = e.target;
  if (!(details instanceof HTMLDetailsElement)) return;
  if (!details.open) return;
  const container = details.closest('[data-faq-single-open]');
  if (!container) return;
  container.querySelectorAll('details[open]').forEach((d) => {
    if (d !== details) d.open = false;
  });
}, true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
